import React from 'react';
import { FormattedMessage } from 'react-intl';
import { push, replace } from 'redux-first-history';
import { useDispatch, useSelector } from 'react-redux';

import Heading from '@starbucks-web/pattern-library/lib/components/heading';
import DialogWithMessages from 'shared/app/components/dialog-with-messages';
import { sharedCallsToAction } from 'shared/app/messages/ctas';
import { getErrorDialogForErrorCode } from 'shared/app/state/errors/account-card-errors';

import { cardRegistrationErrorCodeSelector } from '../../state/selectors/cards';

export const CARD_REGISTRATION_FAILURE_DIALOG_ID =
  'CardRegistrationFailureDialogId';

export const CardRegistrationFailureDialog = () => {
  const dispatch = useDispatch();

  const cardRegistrationErrorCode = useSelector(
    cardRegistrationErrorCodeSelector
  );

  const errorDialog = getErrorDialogForErrorCode(cardRegistrationErrorCode);

  return (
    <DialogWithMessages
      cancelText={<FormattedMessage {...sharedCallsToAction.notNow} />}
      confirmText={<FormattedMessage {...sharedCallsToAction.tryAgain} />}
      onCancel={() => {
        dispatch(replace('/account/cards'));
      }}
      onConfirm={() => {
        dispatch(push('/account/cards/add'));
      }}
    >
      <Heading
        className="pb4 pt1"
        id={CARD_REGISTRATION_FAILURE_DIALOG_ID}
        size="md"
        tagName="h2"
      >
        <FormattedMessage {...errorDialog.header} />
      </Heading>
      <p>
        <FormattedMessage {...errorDialog.message} />
      </p>
    </DialogWithMessages>
  );
};
export default CardRegistrationFailureDialog;
